export default __webpack_public_path__ + "static/media/Mobileshopadmin.d1c5ebd6.m4v";